import React from 'react';

import { useAppBranding } from '../../config/branding';

interface CustomRadioButtonProperties {
  selected: boolean;
  label: string;
  value: string;
  name: string;
  onChangeFunc: (name: string, value: string) => void;
  fontSize?: 'small' | 'medium' | 'large';
}

/**
 * Custom radio button component
 */
function CustomRadioButton(properties: Readonly<CustomRadioButtonProperties>) {
  const branding = useAppBranding();
  const { selected, label, value, name, onChangeFunc, fontSize = 'large' } = properties;
  return (
    <div
      className={`custom-radio-button-wrap ${fontSize}`}
      role="presentation"
      onClick={() => onChangeFunc(name, value)}>
      {selected ? (
        <branding.icons.CheckBoxActiveIcon color="var(--primary-color)" />
      ) : (
        <branding.icons.CheckBoxIcon color="var(--primary-color)" />
      )}
      <p className="radio-button-label">{label}</p>
    </div>
  );
}

export default CustomRadioButton;
